import React from 'react';
import { classNames } from '@panwds/tailwindcss';
import { SubTabList } from './SubTabList.js';
import { useTabsContext } from './TabsContext.js';
export const TabPanel = ({ activeTabId = null, addClassName, children, dataMetrics, dataTestId, forTabId, hideInactiveTabs = false }) => {
    const active = activeTabId === null || activeTabId === forTabId;
    const { orientation } = useTabsContext();
    const isVertical = orientation === 'vertical';
    const hasSubTabListAsChild = React.Children.toArray(children).find((child) => child.type === SubTabList);
    const className = classNames('tw-outline-none', addClassName, !active && 'tw-hidden', isVertical ? 'tw-mx-4 tw-my-1' : 'tw-my-4', !isVertical && !hasSubTabListAsChild && 'tw-ml-4');
    if (!active && !hideInactiveTabs)
        return null;
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'tab-panel', className: className, "aria-labelledby": forTabId, "aria-expanded": active, role: "tabpanel", tabIndex: active ? 0 : -1 }, children));
};
//# sourceMappingURL=TabPanel.js.map